import { router } from './router'
import { createId } from './xeon'
import { vetted } from '../view-drugs/vetted.js'

export function reset() {

  return async ( dispatch, getState, api ) => {

    // Create new id
    dispatch( { type: "xeon.id", data: createId() } )
    // And reset the store
    dispatch( { type: "xeon.drugs", data: {} } )
    dispatch( { type: "xeon.rules", data: {} } )
    dispatch( { type: "xeon.faqs", data: {} } )
    dispatch( { type: "xeon.pmids", data: {} } )

    // Reset vetted
    await dispatch( vetted() )

    return dispatch( router( "drugs" ) )
  }

}
